module.exports = __webpack_public_path__ + "894984133ed6c1c9647980125bd59f89.jpg";